<nav>
	<ng-container *ngFor="let bc of breadcrumbs; let last = last" class="breadcrumb-container">
		<a *ngIf="!last" [routerLink]="bc.url">{{ bc.label }}</a>
		<span *ngIf="last">{{ bc.label }}</span>
		<mat-icon *ngIf="!last" svgIcon="pm-icons:right-arrow" style="width: 12px; height: 12px"></mat-icon>
	</ng-container>
</nav>
